"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = void 0;
const vue_1 = require("vue");
const TranslateMixin_1 = require("../TranslateMixin");
const dialogPolyfill = require('dialog-polyfill');
exports.ConfirmDialog = vue_1.default.component('confirm-dialog', {
    props: {
        message: {
            type: String,
        },
        enableDontShowAgainCheckbox: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            hide: false,
        };
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    watch: {
        hide: function () {
            this.$emit('hide', this.hide);
        },
    },
    methods: {
        accept: function () {
            this.$emit('accept');
        },
        dismiss: function () {
            this.$emit('dismiss');
        },
        show: function () {
            this.$refs['dialog'].showModal();
        },
    },
    mounted: function () {
        (dialogPolyfill.default || dialogPolyfill).registerDialog(this.$refs['dialog']);
    },
    template: `<dialog ref="dialog" class="dialog">
      <form method="dialog">
        <p v-i18n class="newlines">{{ message }}</p>
        <menu class="dialog-menu centered-content">
          <button class="btn btn-lg btn-primary" v-on:click="accept()">Yes</button>
          <button class="btn btn-lg" v-on:click="dismiss()">No</button>
        </menu>
        <input v-if="enableDontShowAgainCheckbox" type="checkbox" v-model="hide" id="dialog-confirm-dismiss" />
        <label v-if="enableDontShowAgainCheckbox" for="dialog-confirm-dismiss">Don't show this again</label>
      </form>
    </dialog>`,
});
//# sourceMappingURL=ConfirmDialog.js.map